console.log('FDR Steps Script Loaded Successfully');

// Helper function to get device type
function getDeviceType() {
    const ua = navigator.userAgent.toLowerCase();
    const width = window.innerWidth;
    
    const isTablet = /(ipad|tablet|playbook|silk)|(android(?!.*mobi))/i.test(ua);
    const isMobile = /mobile|iphone|ipod|android.*mobile|blackberry|opera mini|windows phone|webos/i.test(ua);
    
    if (isTablet) {
        return 'tablet';
    } else if (isMobile) {
        return 'mobile';
    } else if (width <= 768) {
        return 'mobile';
    } else if (width > 768 && width <= 1024 && 'ontouchstart' in window) {
        return 'tablet';
    } else {
        return 'desktop';
    }
}

// Helper function to get cookie value
function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
}

console.log('getCookie function defined');
console.log('getDeviceType function defined');

// Capture utm_source from URL and persist in localStorage for the FDR flow
(function captureUtmSource() {
    var urlParams = new URLSearchParams(window.location.search);
    var utmSource = urlParams.get('utm_source');
    if (utmSource) {
        localStorage.setItem('fdr_utm_source', utmSource);
        console.log('utm_source captured:', utmSource);
    }
})();

// Add click event listener to the button - Set cookie when "Save and Add More" is clicked
document.addEventListener('DOMContentLoaded', function() {
    console.log('DOMContentLoaded - Looking for .js-quick-add-another-item button');
    const addAnotherButton = document.querySelector('.js-quick-add-another-item');
    console.log('Button found:', addAnotherButton);
    if(addAnotherButton) {
        addAnotherButton.addEventListener('click', function() {
            // Set a cookie that expires in 30 days
            const expires = new Date();
            expires.setTime(expires.getTime() + (30 * 24 * 60 * 60 * 1000));
            document.cookie = `quick_add_another=true; expires=${expires.toUTCString()}; path=/`;
            console.log('Cookie set! quick_add_another=true');
            console.log('All cookies:', document.cookie);
        });
    }
});


document.addEventListener('DOMContentLoaded', function () {
  let productInfoData = localStorage.getItem('fdrproductinfo');
  console.log('checking productInfoData',productInfoData)
});

class FdrProductsListWrap extends HTMLElement {
  constructor() {
    super();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const collectionHandle = urlParams.get('collection');
    this.fdrProductsList = this.querySelector('#fdr-products-list-grid');
    this.nextPage = this.getAttribute('data-next');

    if(collectionHandle){
      this.collectionhandle = collectionHandle;
    }else{
      this.collectionhandle = 'best-sellers';
    }

    document.addEventListener("DOMContentLoaded", this.collectionProductsLoad.bind(this))
  }

  collectionProductsLoad() {
    const url = `/collections/${this.collectionhandle}?view=fdr-products`;

    this.productsFetch(url);
  }

  productsFetch(url) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const productGrid = html.getElementById('main-collection-product-grid');
        const productCells = productGrid.querySelectorAll('.grid__item');
        const pagination = html.querySelector('.pagination-wrapper');
        const paginationWraps = document.querySelectorAll('.pagination-wrapper');

        if(productCells){
          productCells.forEach((productCell) => {
            const productUrl = productCell.querySelector('a').getAttribute('href');
            const productHandle = productUrl.replace("/products/", '');
            const templateSuffix = productCell.getAttribute('data-template-suffix');
            const betaTemplates = ['c-beta', 'c-beta-new', 'c-beta-varb', 'air-dancers', 'table-covers', 'feather-flags', 'trade-show'];
            const newProductUrl = betaTemplates.includes(templateSuffix)
              ? `/products/${productHandle}`
              : `${this.nextPage}?collection=${this.collectionhandle}&product=${productHandle}`;

            productCell.querySelectorAll('a').forEach((link) => {
              link.setAttribute('href', newProductUrl);
            })
            this.fdrProductsList.insertAdjacentElement("beforeend", productCell);
          })
        }

        if(paginationWraps){
          paginationWraps.forEach((paginationWrap) => {
            paginationWrap.remove();
          })
        }

        if(pagination){
          const nextButton = pagination.querySelector('a');

          this.fdrProductsList.insertAdjacentElement("afterend", pagination);

          if(nextButton){
            nextButton.addEventListener('click', this.paginationLoad.bind(this));

            nextButton.innerText = 'Load More';
          }
        }
      });
  }

  paginationLoad(event) {
    event.preventDefault();

    const nextUrl = event.target.getAttribute('href');

    event.target.innerText = 'Loading...';
    this.productsFetch(nextUrl);
  }
}

customElements.define('fdr-products-list-wrap', FdrProductsListWrap);

class FdrProductsStep extends HTMLElement {
  constructor() {
    super();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const collectionHandle = urlParams.get('collection');
    const productHandle = urlParams.get('product');
    const productVariant = urlParams.get('variant');
    this.submitButton = this.getAttribute('data-button');
    this.addAnotherItemButton = this.getAttribute('data-add-another-item');

    if(productHandle){
      this.productHandle = productHandle;
    }else{
      this.productHandle = 'air-dancers-custom-inflatable-tube-man';
    }
    
    if(collectionHandle){
      this.collectionhandle = collectionHandle;
    }else{
      this.collectionhandle = 'best-sellers';
    }    
    if(productVariant){
      this.productVariant = productVariant;
    }

    document.addEventListener("DOMContentLoaded", this.productFetch.bind(this))
  }

  productFetch(){
    
    // Get design instructions from URL if available
    const urlParams = new URLSearchParams(window.location.search);
    const designInstructions = urlParams.get('design_instructions');
    
    const url = `/products/${this.productHandle}?variant=${this.productVariant}&view=fdr-product`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const productContent = html.querySelector('.fdr-product-content');

        if(productContent){
          const productTitle = productContent.querySelector('.js-product-title').innerText.replace(/&/g, '');
          const producTitleWrap = document.querySelector('.js-dynamic-product-title');
          const producTitleContent = document.querySelector('.dynamic-product-title-wrap');

          if(producTitleWrap){
            producTitleWrap.innerText = productTitle;
            producTitleContent.classList.remove('hide');
          }
          productContent.querySelector('[data-step="addon"]').remove();
          this.insertAdjacentElement('beforeend', productContent);
          
          // Select the correct variant based on URL parameter
          setTimeout(() => {
            const variantRadios = this.querySelector('variant-fdr-radios');
            if (variantRadios && this.productVariant) {
              // Get variant data from the JSON script in the inserted content
              const variantJsonScript = variantRadios.querySelector('[type="application/json"]');
              if (variantJsonScript) {
                const variantData = JSON.parse(variantJsonScript.textContent);
                const targetVariant = variantData.find(v => v.id == this.productVariant);
                
                if (targetVariant) {
                  console.log('Target variant found:', targetVariant);
                  
                  // Select option1 (size)
                  if (targetVariant.option1) {
                    const option1Radio = variantRadios.querySelector(`fieldset[data-option="option1"] input[value="${targetVariant.option1}"]`);
                    if (option1Radio) {
                      console.log('Clicking option1:', targetVariant.option1);
                      option1Radio.click();
                    }
                  }
                  
                  // Longer delay to let option1 update
                  setTimeout(() => {
                    // Select option2 (podium) - force enable if needed
                    if (targetVariant.option2) {
                      const option2Radio = variantRadios.querySelector(`fieldset[data-option="option2"] input[value="${targetVariant.option2}"]`);
                      console.log('Option2 radio found:', option2Radio);
                      
                      if (option2Radio) {
                        // Remove disabled attribute and class
                        option2Radio.removeAttribute('disabled');
                        option2Radio.classList.remove('disabled');
                        const option2Label = variantRadios.querySelector(`fieldset[data-option="option2"] label[for="${option2Radio.id}"]`);
                        if (option2Label) {
                          option2Label.style.display = '';
                        }
                        
                        console.log('Clicking option2:', targetVariant.option2);
                        option2Radio.click();
                      }
                    }
                    
                    // Another delay before option3
                    setTimeout(() => {
                      // Select option3 (accessories) - force enable if needed
                      if (targetVariant.option3) {
                        const option3Radio = variantRadios.querySelector(`fieldset[data-option="option3"] input[value="${targetVariant.option3}"]`);
                        if (option3Radio) {
                          // Remove disabled attribute and class
                          option3Radio.removeAttribute('disabled');
                          option3Radio.classList.remove('disabled');
                          const option3Label = variantRadios.querySelector(`fieldset[data-option="option3"] label[for="${option3Radio.id}"]`);
                          if (option3Label) {
                            option3Label.style.display = '';
                          }
                          
                          console.log('Clicking option3:', targetVariant.option3);
                          option3Radio.click();
                        }
                      }
                    }, 200);
                  }, 300);
                }
              }
            }
          }, 600);
          
          // Populate design instructions field if parameter exists
          if (designInstructions) {
            var checkDesignField = setInterval(() => {
              const designField = document.getElementById('quick-add-modal-form-message');
              if (designField) {
                designField.value = decodeURIComponent(designInstructions);
                clearInterval(checkDesignField);
              }
            }, 100);
          }
          
          this.fileUploadScript();
          this.formHandle();
          this.uploadUpdate();
          this.injectPdpUploads();
        }
      })
  }

  fileUploadScript(){
    const file_upload_script = document.createElement('script');

    file_upload_script.setAttribute('src','https://assets.cloudlift.app/api/assets/upload.js?shop=lookourway.myshopify.com');
    
    this.appendChild(file_upload_script);
  }

  // Injects placeholder filepond items for files the user already uploaded on
  // the PDP (Cloudlift puts them in input[name="properties[upload_N]"] and
  // global-cro.js persists them to localStorage at click time). Each placeholder
  // is a real <li class="filepond--item" data-filepond-item-state="processing-complete">
  // so it visually matches Cloudlift's own items, counts toward the
  // "Uploaded: X/5" counter, and the user can remove it with the same X.
  injectPdpUploads(){
    const self = this;
    let raw;
    try { raw = window.localStorage.getItem('fdrPdpUploads'); } catch (_) { raw = null; }
    if (!raw) return;
    let pdpUploads = [];
    try { pdpUploads = JSON.parse(raw) || []; } catch (_) { pdpUploads = []; }
    if (!Array.isArray(pdpUploads) || pdpUploads.length === 0) return;

    const MAX_FILES = 5;

    const escapeAttr = (s) => String(s == null ? '' : s).replace(/[<>&"']/g, (c) => ({
      '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;', "'": '&#39;'
    })[c]);

    // Build / refresh passthrough <li> items directly inside FilePond's list.
    const renderAll = (form, scope) => {
      // Wipe previous passthrough items and hidden inputs.
      scope.querySelectorAll('li.pdp-passthrough-li').forEach((n) => n.remove());
      form.querySelectorAll('input.js-pdp-upload-hidden').forEach((n) => n.remove());

      const list = scope.querySelector('ul.filepond--list');
      if (!list) return; // tryAttach guarantees this exists

      pdpUploads.forEach((file, idx) => {
        const li = document.createElement('li');
        li.className = 'pdp-passthrough-li';
        li.setAttribute('data-pdp-upload-idx', String(idx));
        li.style.cssText = 'list-style:none;margin:0.25em;';
        li.innerHTML = (
          '<div style="display:flex;align-items:center;justify-content:space-between;gap:8px;' +
          'padding:4px 7px 4px 10px;background:#fff;box-shadow:0 1px 1px #0000001f;' +
          'border:2px solid #868585;border-radius:4px;min-height:2.75em;">' +
            '<div style="display:flex;flex-direction:column;min-width:0;flex:1;overflow:hidden;">' +
              '<span style="font-size:15px;color:#111;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' +
                escapeAttr(file.name || ('PDP upload ' + (idx + 1))) +
              '</span>' +
              '<span style="font-size:10px;color:#888;">from product page</span>' +
            '</div>' +
            '<button type="button" class="js-pdp-upload-remove" aria-label="Remove file" ' +
            'data-pdp-upload-idx="' + idx + '" ' +
            'style="flex:0 0 20px;width:20px;min-width:20px;height:20px;min-height:20px;padding:0;border-radius:50%;' +
            'border:1px solid #d93f66;background:#fff;color:#d93f66;cursor:pointer;font-size:11px;line-height:1;' +
            'letter-spacing:0;text-transform:none;font-weight:normal;' +
            'display:inline-flex;align-items:center;justify-content:center;align-self:center;box-shadow:none;">' +
              '\u2715' +
            '</button>' +
          '</div>'
        );
        list.appendChild(li);

        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'properties[upload_pdp_' + (idx + 1) + ']';
        hidden.value = file.url;
        hidden.className = 'js-pdp-upload-hidden';
        form.appendChild(hidden);
      });

      syncCounterAndBrowse(scope);
    };

    const syncCounterAndBrowse = (scope) => {
      const list = scope.querySelector('ul.filepond--list');
      const realCount = list ? list.querySelectorAll('li.filepond--item').length : 0;
      const pdpCount = pdpUploads.length;
      const total = realCount + pdpCount;

      const counter = document.querySelector('.cl-upload--counter');
      if (counter) {
        const desired = total + '/' + MAX_FILES;
        if (counter.textContent !== desired) counter.textContent = desired;
      }

      // Block new uploads when we're at the combined limit. We toggle a
      // pointer-events lock on Cloudlift's drop label / browse trigger.
      const candidates = [
        scope.querySelector('.filepond--drop-label'),
        scope.querySelector('.filepond--browser'),
        scope.querySelector('.cl-upload--browse'),
        scope.querySelector('.filepond--label-action')
      ];
      const atLimit = total >= MAX_FILES;
      candidates.forEach((el) => {
        if (!el) return;
        if (atLimit) {
          el.style.pointerEvents = 'none';
          el.style.opacity = '0.5';
          el.setAttribute('data-pdp-disabled', 'true');
        } else if (el.getAttribute('data-pdp-disabled') === 'true') {
          el.style.pointerEvents = '';
          el.style.opacity = '';
          el.removeAttribute('data-pdp-disabled');
        }
      });

      // Hard guard: also disable the actual <input type="file"> so a click
      // bubbling past Cloudlift's UI can't bypass the cap.
      const fileInputs = scope.querySelectorAll('input[type="file"].filepond--browser, .filepond--browser input[type="file"], input[type="file"]');
      fileInputs.forEach((inp) => {
        if (atLimit) inp.setAttribute('disabled', 'disabled');
        else if (inp.getAttribute('data-pdp-disabled') === 'true' || inp.hasAttribute('disabled')) {
          inp.removeAttribute('disabled');
        }
      });
      scope._pdpAtLimit = atLimit;
    };

    const wireRemovals = (form, scope) => {
      // One delegated listener for all current + future remove buttons.
      scope.addEventListener('click', function (e) {
        const btn = e.target.closest('.js-pdp-upload-remove');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        const idx = parseInt(btn.getAttribute('data-pdp-upload-idx'), 10);
        if (Number.isNaN(idx)) return;
        pdpUploads.splice(idx, 1);
        try {
          if (pdpUploads.length) {
            window.localStorage.setItem('fdrPdpUploads', JSON.stringify(pdpUploads));
          } else {
            window.localStorage.removeItem('fdrPdpUploads');
          }
        } catch (_) { /* noop */ }
        renderAll(form, scope);
      });
    };

    // Wait until Cloudlift has built its filepond list, then attach. We watch
    // Cloudlift's list externally (not as a parent of our nodes) so we never
    // create a parent->child mutation feedback loop with FilePond.
    let wired = false;
    const tryAttach = () => {
      const form = self.querySelector('form');
      if (!form) return false;
      const list = self.querySelector('ul.filepond--list');
      if (!list) return false;
      // Mount/refresh our list (sibling to FilePond, not inside it).
      renderAll(form, self);
      if (!wired) {
        wireRemovals(form, self);
        // Re-sync counter and at-limit state when Cloudlift adds/removes its
        // own files. We only read from its list — we never mutate it directly.
        // We DO call the native X on excess <li> nodes so FilePond cleanly
        // unwinds the upload state.
        const listObs = new MutationObserver((mutations) => {
          if (!self.contains(list)) { listObs.disconnect(); return; }
          // Enforce combined cap. Count real items; if total > MAX, click the
          // X on the most recently added items until we are back at the cap.
          const realItems = list.querySelectorAll('li.filepond--item');
          const total = realItems.length + pdpUploads.length;
          if (total > MAX_FILES) {
            const excess = total - MAX_FILES;
            // Prefer to remove items we just saw added in this batch.
            const added = [];
            mutations.forEach((m) => {
              m.addedNodes && m.addedNodes.forEach((n) => {
                if (n.nodeType === 1 && n.matches && n.matches('li.filepond--item')) added.push(n);
              });
            });
            const victims = added.length >= excess ? added.slice(-excess)
              : Array.from(realItems).slice(-excess);
            victims.forEach((li) => {
              const x = li.querySelector('.filepond--action-remove-item');
              if (x) {
                // Force the button enabled in case Cloudlift styled it off.
                x.style.pointerEvents = 'auto';
                x.style.opacity = '1';
                x.style.visibility = 'visible';
                x.removeAttribute('disabled');
                x.click();
              } else {
                li.remove();
              }
            });
            // Flash counter red briefly.
            const errEl = document.querySelector('.cl-upload--counter');
            if (errEl) {
              errEl.textContent = 'Maximum 5 files reached';
              errEl.style.color = '#c00';
              clearTimeout(self._pdpFlashTimer);
              self._pdpFlashTimer = setTimeout(() => {
                errEl.style.color = '';
                syncCounterAndBrowse(self);
              }, 2500);
            }
          }
          syncCounterAndBrowse(self);
        });
        listObs.observe(list, { childList: true, subtree: false });

        // Cloudlift rewrites .cl-upload--counter textContent every time its
        // own count changes, undoing our combined value. Watch the counter
        // node itself and rewrite it back whenever Cloudlift mutates it.
        const counterEl = document.querySelector('.cl-upload--counter');
        if (counterEl) {
          const counterObs = new MutationObserver(() => {
            const realCount = list.querySelectorAll('li.filepond--item').length;
            const total = realCount + pdpUploads.length;
            const desired = total + '/' + MAX_FILES;
            if (counterEl.textContent !== desired) {
              counterEl.textContent = desired;
            }
          });
          counterObs.observe(counterEl, { childList: true, characterData: true, subtree: true });
        }

        // Capture-phase guard: stop click/keydown on the upload area from
        // opening the file picker once we are at the combined cap. This
        // catches the case where Cloudlift's own click handler runs before
        // pointer-events:none takes effect (or where the actual file input
        // is clicked programmatically by Cloudlift on drop/drag).
        const uploadArea = self.querySelector('.cl-upload--area, .filepond--root, .product-custom-upload__upload-new-wrapper') || self;
        const blockIfAtLimit = (e) => {
          if (!self._pdpAtLimit) return;
          // Allow clicks on our own remove buttons and on existing filepond
          // items (remove buttons inside real uploads).
          if (e.target.closest('.js-pdp-upload-remove')) return;
          if (e.target.closest('li.filepond--item .filepond--file-action-button')) return;
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        };
        uploadArea.addEventListener('click', blockIfAtLimit, true);
        uploadArea.addEventListener('keydown', blockIfAtLimit, true);
        // Catch drag-and-drop too.
        uploadArea.addEventListener('drop', blockIfAtLimit, true);

        // FilePond emits 'FilePond:addfile' on its root each time a new file
        // is queued. If the combined count would exceed MAX_FILES, find the
        // freshly-added <li.filepond--item> and click its remove button so
        // FilePond cleanly aborts the upload. This is the only reliable way
        // to enforce the combined cap because Cloudlift's <label for> opens
        // the file picker via native browser action (no JS click to block)
        // and FileList is immutable so we can't filter the input.files.
        const filepondRoots = self.querySelectorAll('.filepond--root');
        filepondRoots.forEach((root) => {
          root.addEventListener('FilePond:addfile', (ev) => {
            // Defer to next tick so FilePond has appended the <li> to its list.
            setTimeout(() => {
              const liveList = self.querySelector('ul.filepond--list');
              if (!liveList) return;
              const realItems = liveList.querySelectorAll('li.filepond--item');
              const total = realItems.length + pdpUploads.length;
              if (total <= MAX_FILES) return;
              // Too many. Remove the most recently added items until we are
              // back at the cap. We click their native FilePond X to let
              // FilePond unwind state cleanly (abort upload, free memory).
              const excess = total - MAX_FILES;
              const victims = Array.from(realItems).slice(-excess);
              victims.forEach((li) => {
                const x = li.querySelector('.filepond--action-remove-item');
                if (x) x.click();
                else li.remove();
              });
              // Show Cloudlift's native max-files toast if available, else log.
              const msgEl = document.querySelector('#quick-add-modal-form-message');
              const errEl = document.querySelector('.cl-upload--counter');
              if (errEl) {
                const original = errEl.textContent;
                errEl.textContent = 'Maximum 5 files reached';
                errEl.style.color = '#c00';
                setTimeout(() => {
                  errEl.style.color = '';
                  syncCounterAndBrowse(self);
                }, 2500);
              }
            }, 0);
          }, true);
        });

        wired = true;
      }
      return true;
    };

    const interval = setInterval(() => {
      if (tryAttach()) clearInterval(interval);
    }, 150);
    setTimeout(() => clearInterval(interval), 15000);
  }

  fileUploadStatus(){
    const fileUploadObserver = new MutationObserver((mutationsList, observer) => {
      // Iterate through each mutation
      for (const mutation of mutationsList) {
        // Check if nodes were added to the DOM
        if (mutation.type === "childList") {
          // Check if any added node has the desired class
          const addedNodes = Array.from(mutation.addedNodes);
          const hasFilepondItem = addedNodes.some((node) =>
            node.classList.contains("filepond--item")
          );
  
          if (hasFilepondItem) {
            // Add the spinner class to the <ul> element
            const ulElement = document.querySelector("ul.filepond--list");
            if (ulElement) {
              const submitButton = this.querySelector('.js-quick-next-submit');
              submitButton.disabled = true;
              submitButton.classList.add("disabled");
              const saveandmore = this.querySelector('.js-quick-add-another-item');
              // saveandmore.setAttribute("disabled", 'disabled');
              // saveandmore.classList.add("disabled");
              var intervalMatch = setInterval(doStuffCheck, 100);
              function doStuffCheck() {
                var liLength = $("ul.filepond--list li.filepond--item").length;
                var processedLength = $('ul.filepond--list li.filepond--item[data-filepond-item-state="processing-complete"]').length;
                
                if (liLength == processedLength) {
                  // $(submitButton).attr("disabled", false); 
                  // $(saveandmore).attr("disabled", false); 
                  clearInterval(intervalMatch);
                  submitButton.classList.remove("disabled");
                  submitButton.disabled = false;
                  saveandmore.classList.remove("disabled");
                }
              }
            }
          }
        }
      }
    });
    const targetNode = document.querySelector("ul.filepond--list");
    const config = { childList: true };
    fileUploadObserver.observe(targetNode, config);
  }

  formHandle() {
  const nextUrl = `https://lookourway.com/pages/free-design-request-step-4-5?collection=${this.collectionhandle}&product=${this.productHandle}`;
  var personalInforData = localStorage.getItem("fdrpersonalinfo");
  const requiredFields = this.querySelectorAll('.js-required-field');
  const submitButton = this.querySelector('.js-quick-next-submit');
  const addAnotherItemButton = this.querySelector('.js-quick-add-another-item');
  let formSubmitWrap = this.querySelector('.quick-add-modal-form-submit');

  submitButton.innerHTML = this.submitButton + "<i class=\"fal fa-angle-right ion-md-add\"></i>";
  addAnotherItemButton.innerHTML = "<i class=\"fal fa-angle-left ion-md-add\"></i>" + this.addAnotherItemButton;

  const getResultData = (form) => {
    const validFormData = new FormData(form);
    let result = {};

    for (const pair of validFormData.entries()) {
      let key = pair[0];
      let value = pair[1];
      if (key.includes('[')) {
        const [baseKey, subKey] = key.split(/\[|\]/).filter(Boolean);
        if (!result[baseKey]) result[baseKey] = {};
        if (subKey) {
          result[baseKey][subKey] = value;
        } else {
          if (!Array.isArray(result[baseKey])) result[baseKey] = [];
          result[baseKey].push(value);
        }
      } else {
        result[key] = value;
      }
    }

    let titleElement = document.querySelector('.quick-add-modal--content .quick-add-modal-product__title');
    if (titleElement) result['title'] = titleElement.textContent.trim();

    let priceElement = document.querySelector('.quick-add-modal--content .quick-add-modal-product--price-wrap .price-item.price-item--regular');
    if (priceElement) result['price'] = priceElement.textContent.trim();

    let previewImageElement = document.querySelector('.quick-add-modal--content .quick-add-modal-product--media-list .quick-add-modal-product__media-item.is-active img');
    if (previewImageElement) result['image'] = previewImageElement.getAttribute('src').split('?')[0];

    let variantsElements = document.querySelectorAll('variant-fdr-radios .js-form--label-value');
    let variants = [];
    variantsElements.forEach((el) => variants.push(el.textContent.trim()));
    result['variants'] = variants.join(' / ');
    result['collection'] = this.collectionhandle;
    result['product'] = this.productHandle;

    return result;
  };

  const validateFields = () => {
    const textField = document.getElementById('quick-add-modal-form-message');
    const uploadedFileItems = document.querySelectorAll('.filepond--item');
    const isTextFilled = textField && textField.value.trim().length > 0;
    const isFileUploaded = uploadedFileItems.length > 0;
    return isTextFilled || isFileUploaded;
  };

  const handleSubmit = (isFinalStep) => {
    const form = this.querySelector('form');
    let result = getResultData(form);
    let validQueryDataJson = [];
    const savedData = localStorage.getItem('fdrproductinfo');
    if (savedData) validQueryDataJson = JSON.parse(savedData);
    validQueryDataJson.push(result);
    const validQueryData = JSON.stringify(validQueryDataJson);

    const isValid = validateFields();

    if (isValid) {
      localStorage.setItem("fdrproductinfo", validQueryData);
      // PDP-passthrough uploads have now been committed into fdrproductinfo as
      // properties[upload_pdp_*]. Clear the staging key so the next product
      // added ("Save and add more") doesn't re-inject the same files.
      try { window.localStorage.removeItem('fdrPdpUploads'); } catch (_) { /* noop */ }
      window.location.href = isFinalStep ? nextUrl : '/pages/fdr-step-1';
    } else {
      if (!document.querySelector('.js-valide-form-label')) {
        const msg = isFinalStep ? 'Please fill out your design vision!' : 'Please Complete Highlighted Fields!';
        const testClass = isFinalStep ? 'test1' : 'test2';
        formSubmitWrap.insertAdjacentHTML('afterbegin', `<div class="js-valide-form-label ${testClass}">${msg}</div>`);
      }
    }
  };

  submitButton.addEventListener("click", () => handleSubmit(true));
  addAnotherItemButton.addEventListener("click", () => handleSubmit(false));

  requiredFields.forEach((requiredField) => {
    requiredField.addEventListener('change', (e) => {
      const field_value = e.target.value;
      if (field_value !== '') {
        e.target.classList.remove("not-valid");
        const errorLabel = document.querySelector('.js-valide-form-label');
        if (errorLabel) errorLabel.remove();
      }
    });
  });
}


  uploadUpdate(){
    var intervalCheckFileUpload = setInterval(() => {
      if ($("ul.filepond--list").length > 0) {
        this.fileUploadStatus();
        clearInterval(intervalCheckFileUpload);
      }
    }, 100);
  }
}

customElements.define('fdr-product-step', FdrProductsStep);

class FdrProductAddonStep extends HTMLElement {
  constructor() {
    super();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const collectionHandle = urlParams.get('collection');
    const productHandle = urlParams.get('product');
    const productVariant = urlParams.get('variant');

    if(productHandle){
      this.productHandle = productHandle;
    }else{
      this.productHandle = 'air-dancers-custom-inflatable-tube-man';
    }
    
    if(collectionHandle){
      this.collectionhandle = collectionHandle;
    }else{
      this.collectionhandle = 'best-sellers';
    }   
    if(productVariant){
      this.productVariant = productVariant;
    }

    document.addEventListener("DOMContentLoaded", this.productFetch.bind(this))
  }

  productFetch(){
    console.log('test9g');
    console.log('this.productHandle',this.productHandle);
    console.log('this.productVariant',this.productVariant);
    var option1 = $('#product-variants option[value="'+this.productVariant+'"]').data('option1');
    var option2 = $('#product-variants option[value="'+this.productVariant+'"]').data('option2');
    var option3 = $('#product-variants option[value="'+this.productVariant+'"]').data('option3');
    console.log(option1)
    console.log(option2);
    console.log(option3);
    
    $('#product-variants + input[name="id"]').val(this.productHandle);
    $('variant-fdr-radios .product-form__input[data-index="1"] input[value="'+option1+'"]').prop('checked', true);
    $('variant-fdr-radios .product-form__input[data-index="2"] input[value="'+option2+'"]').prop('checked', true);
    $('variant-fdr-radios .product-form__input[data-index="3"] input[value="'+option3+'"]').prop('checked', true);
    


    const url = `/products/${this.productHandle}?view=fdr-product`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const productContent = html.querySelector('[data-step="addon"]');

        if(productContent){
          productContent.classList.add('active');
          productContent.querySelector('.js-quick-add-submit').innerText = fdrProductAddon.button;
          productContent.querySelector('.js-quick-no-submit').innerText = fdrProductAddon.no_button;
          this.querySelector('form').insertAdjacentElement('beforeend', productContent);

          this.addonsFunctionality();
          this.addonsVariantChange();
          this.submitAddons();
        }
      })
  }
  
  addonsFunctionality(){
    const addons = this.querySelectorAll('.js-addon-item');

    addons.forEach((addon) => {
      addon.addEventListener('click', (e) => {
        e.currentTarget.closest('.quick-add-modal-form-addon__item').classList.toggle('active');
        var vid = e.currentTarget.closest('.quick-add-modal-form-addon__item').querySelector('input').getAttribute('data-vid');console.log(vid);

        if(e.currentTarget.closest('.quick-add-modal-form-addon__item').classList.contains('active')){
          e.currentTarget.closest('.quick-add-modal-form-addon__item').querySelector('input').value = vid;
        }else{
          e.currentTarget.closest('.quick-add-modal-form-addon__item').querySelector('input').value = '';
        }

        e.currentTarget.closest('.quick-add-modal-form-addon__item').querySelector('input').checked = !e.currentTarget.closest('.quick-add-modal-form-addon__item').querySelector('input').checked;
      })
    })
  }

  addonsVariantChange(){
    const addonOptions = this.querySelectorAll('select');
    
    addonOptions.forEach((addonOption) => {
      addonOption.addEventListener('change', (e) => {
        const addonParent = e.currentTarget.closest('.quick-add-modal-form-addon__item');
        const addonParentSelects = addonParent.querySelectorAll('select');
        const optionProductId = e.currentTarget.getAttribute('data-productid');
        const addonProductJson = JSON.parse(this.querySelector('.quick-add-modal-form-addon-json-' + optionProductId).textContent);
        let optionArray = [];
        const addonParentvid = addonParent.querySelector('[name="quick-addons"]');

        addonParentSelects.forEach((addonParentSelect) => {
          const selectValue = addonParentSelect.value;

          optionArray.push(selectValue);
        })

        const selectedAddonVariant = addonProductJson.variants.find((variant) => {
          return !variant.options
            .map((option, index) => {
              return optionArray[index] === option;
            })
            .includes(false);
        })

        addonParentvid.setAttribute('data-vid', selectedAddonVariant.id);
        if(addonParentvid.checked){
          addonParentvid.value = selectedAddonVariant.id;
        }
      })
    })
  }

  submitAddons(){
    var integro_url = "https://hook.us1.make.com/4wtbzamol7edwitpig5dvi2ur2yhlw0c";
    const submitAddonButton = this.querySelector('.js-quick-add-submit');
    const noAddonButton = this.querySelector('.js-quick-no-submit');
    var personalInforData = localStorage.getItem("fdrpersonalinfo");
    var productInfoData = localStorage.getItem("fdrproductinfo");
    console.log('personalInforData 3',personalInforData)
    console.log('productInfoData 3',productInfoData)

    submitAddonButton.addEventListener('click', (e) => {
      const fdorm = e.target.closest('form');
      const validFormData = new FormData(fdorm);
      //let validQueryData = new URLSearchParams(validFormData).toString();
      let validQueryData = productInfoData;

      if(validQueryData != ''){
        validQueryData = personalInforData + '&' + validQueryData;
      }else{
        validQueryData = personalInforData;
      }

      // Include utm_source for wholesale attribution
      var fdrUtmSource = localStorage.getItem('fdr_utm_source');
      if (fdrUtmSource) {
        validQueryData += '&utm_source=' + encodeURIComponent(fdrUtmSource);
      }

      e.target.innerText = "Submitting..."
      $(e.target).prop("disabled", true);

      $.ajax({
        type: "POST",
        url: integro_url,
        data: validQueryData,
        dataType: "json",
        success: function (data) {
          if (data) {
            console.log(data);
            console.log(data.draft_name);
            window.location.href =
              "/pages/thank-you-fdr?name=" +
              data.draft_name +
              "&details=" +
              data.details;
          }
        },
        fail: function (jqXHR, textStatus) {
          console.log(jqXHR + " -- " + textStatus);
          $loadingbtn.removeClass("spinning");
          alert("Process failed, please reload the page and try again");
        },
      });
    })

    noAddonButton.addEventListener('click', (e) => {      
      e.target.innerText = "Submitting..."
      $(e.target).prop("disabled", true);

      let validQueryData = productInfoData;
      if(validQueryData != ''){
        validQueryData = personalInforData + '&' + validQueryData;
      }else{
        validQueryData = personalInforData;
      }

      // Include utm_source for wholesale attribution
      var fdrUtmSource = localStorage.getItem('fdr_utm_source');
      if (fdrUtmSource) {
        validQueryData += '&utm_source=' + encodeURIComponent(fdrUtmSource);
      }

      $.ajax({
        type: "POST",
        url: integro_url,
        data: validQueryData,
        dataType: "json",
        success: function (data) {
          if (data) {
            console.log(data);
            console.log(data.draft_name);
            window.location.href =
              "/pages/thank-you-fdr?name=" +
              data.draft_name +
              "&details=" +
              data.details;
          }
        },
        fail: function (jqXHR, textStatus) {
          console.log(jqXHR + " -- " + textStatus);
          $loadingbtn.removeClass("spinning");
          alert("Process failed, please reload the page and try again");
        },
      });
    })
  }
}

customElements.define('fdr-product-addon-step', FdrProductAddonStep);

class FdrPersonalInfoForm extends HTMLElement {
  constructor() {
    super();

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const collectionHandle = urlParams.get('collection');
    this.productHandle = urlParams.get('product');
    this.productVariant = urlParams.get('variant');
    this.form = this.querySelector('form');
    this.submitButton = this.querySelector('.js-personal-info-submit');
    this.addAnotherItemButton = this.querySelector('.js-quick-add-another-item');
    this.requiredFields = this.querySelectorAll('.js-required-field');
    this.waitModal = document.querySelector('.personal-info-wait-modal');
    // this.confirmationEmail = this.querySelector('.js-confirmation-email');
    
    if(collectionHandle){
      this.collectionhandle = collectionHandle;
    }else{
      this.collectionhandle = 'best-sellers';
    }

    this.loadSavedPersonalInfo();
    this.requiredFieldsEvent();
    this.submitButton.addEventListener("click", this.formHandle.bind(this));
    this.addAnotherItemButton.addEventListener("click", this.saveAndAddMore.bind(this));
  }

  loadSavedPersonalInfo() {
    let productInfoData = localStorage.getItem('fdrpersonalinfo');
    console.log('productInfoData 4',productInfoData)
    if (productInfoData !== undefined && productInfoData !== '' && productInfoData !== null) {
      let params = new URLSearchParams(productInfoData);
      let email = params.get('email');
      let name = decodeURIComponent(params.get('name').replace(/\+/g, ' '));
      let company = params.get('company');
      let phone = decodeURIComponent(params.get('phone'));
      let optIn = params.get('optin');
      this.querySelector('#fdr-personal-info-email').value = email;
      this.querySelector('#fdr-personal-info-name').value = name;
      this.querySelector('#fdr-personal-info-company').value = company;
      this.querySelector('#fdr-personal-info-phone').value = phone;
      if (optIn == 'on') {
        this.querySelector('#fdr-personal-info-optin').checked = true;
      } else {
        this.querySelector('#fdr-personal-info-optin').checked = false;
      }      
    }
  }

  formHandle(){
    const validForm = this.requiredFieldsValid();
    const validFormData = new FormData(this.form);
    const validQueryData = new URLSearchParams(validFormData).toString();
    const nextUrl = this.getAttribute('data-next');
    const nextSkipUrl = this.getAttribute('data-next-skip');

    if(validForm){
      localStorage.setItem("fdrpersonalinfo", '');
      localStorage.setItem("fdrpersonalinfo", validQueryData);
      if(this.productHandle){
        // window.location.href = nextSkipUrl + '?product=' + this.productHandle+ '&variant=' + this.productVariant;
        this.submitAddons();
      }else{
        window.location.href = nextUrl;
      }
    }else{
      
    }
  }

  requiredFieldsEvent(){
    this.requiredFields.forEach((requiredField) => {
      requiredField.addEventListener('keyup', function(e){
        const fieldValue = e.target.value;

        if(fieldValue == ''){
          e.target.classList.add("not-valid");
        }else{
          e.target.classList.remove("not-valid");
        }
      })
    })

    /*
    this.confirmationEmail.addEventListener('keyup', function(e){
      const lEmail = this.form.querySelector('[name="email"]');
      const cEmail = e.target;
      const cEmailWrap = e.target.closest(".fdr-personal-info-field");
      const emailvalidNote = this.form.querySelector(".js-valide-email-label");

      if(lEmail.value != cEmail.value){
        if(emailvalidNote){
          emailvalidNote.innerText = "Not valid email!";
        }else{
          cEmailWrap.insertAdjacentHTML('beforeend', '<span class="js-valide-email-label">Not valid email!</span>');
        }
      }else{
        if(emailvalidNote){
          emailvalidNote.remove();
        }
      }
    })
    
    this.confirmationEmail.addEventListener('change', function(e){
      const lEmail = this.form.querySelector('[name="email"]');
      const cEmail = e.target;
      const cEmailWrap = e.target.closest(".fdr-personal-info-field");
      const emailvalidNote = this.form.querySelector(".js-valide-email-label");

      if(lEmail.value != cEmail.value){
        if(emailvalidNote){
          emailvalidNote.innerText = "Not valid email!";
        }else{
          cEmailWrap.insertAdjacentHTML('beforeend', '<span class="js-valide-email-label">Not valid email!</span>');
        }
      }else{
        if(emailvalidNote){
          emailvalidNote.remove();
        }
      }
    })
    */
  }

  requiredFieldsValid(){
    var required_field_valid = true;
    const lEmailField = this.form.querySelector('[name="email"]');
    // const cEmailField = this.form.querySelector('[name="confirmation email"]');
    const emailvalidNote = this.form.querySelector(".js-valide-email-label");

    this.requiredFields.forEach((requiredField) => {
      if(requiredField.value != ''){
        
      }else{
        required_field_valid = false;
        requiredField.classList.add("not-valid");
      }
    })

    /*
    if(lEmailField.value != cEmailField.value){
      required_field_valid = false;
      if(emailvalidNote){
        emailvalidNote.innerText = "Not valid email!";
      }else{
        cEmailWrap.insertAdjacentHTML('beforeend', '<span class="js-valide-email-label">Not valid email!</span>');
      }
    }else{
      if(emailvalidNote){
        emailvalidNote.remove();
      }
    }
    */

    return required_field_valid;
  }

submitAddons(){
    var integro_url = "https://hook.us1.make.com/uw3p03klh087tlfbf63hc5abmund6sub";
    var personalInforData = localStorage.getItem("fdrpersonalinfo");
    // Guard against null/undefined so the final submit does not throw a TypeError
    // when localStorage was cleared between Step 3 and Step 4-5.
    var rawProductInfo = localStorage.getItem("fdrproductinfo");
    var productInfoData = rawProductInfo ? rawProductInfo.replace(/&/g, '') : '';

    console.log('submitAddons: personalInforData = ', personalInforData);
    console.log('submitAddons: productInfoData = ', productInfoData);
    
    let validQueryData = productInfoData;
    if(validQueryData != ''){
      validQueryData = personalInforData + '&products=' + validQueryData;
    }else{
      validQueryData = personalInforData;
    }

    // Add the cookie value to the payload
    const quickAddAnother = getCookie('quick_add_another');
    console.log('Retrieved cookie value:', quickAddAnother);
    if (quickAddAnother) {
      validQueryData += '&quick_add_another=' + quickAddAnother;
      console.log('Cookie added to payload');
    } else {
      console.log('No cookie found or cookie is null');
    }
    
    // Add device type to the data
    var deviceType = getDeviceType();
    validQueryData += '&device_type=' + encodeURIComponent(deviceType);
    validQueryData += '&user_agent=' + encodeURIComponent(navigator.userAgent);
    validQueryData += '&viewport=' + encodeURIComponent(window.innerWidth + 'x' + window.innerHeight);
    console.log('Device info added: type=' + deviceType + ', viewport=' + window.innerWidth + 'x' + window.innerHeight);

    // Capture GA4 client_id from _ga cookie so Make.com can send events
    // with the correct client_id via Measurement Protocol (fixes (direct)/(none) attribution)
    const gaCookie = getCookie('_ga');
    const ga4ClientId = gaCookie ? gaCookie.split('.').slice(-2).join('.') : null;
    console.log('GA4 client_id from _ga cookie:', ga4ClientId);
    if (ga4ClientId) {
      validQueryData += '&ga4_client_id=' + encodeURIComponent(ga4ClientId);
    }

    // Include utm_source for wholesale attribution
    var fdrUtmSource = localStorage.getItem('fdr_utm_source');
    if (fdrUtmSource) {
      validQueryData += '&utm_source=' + encodeURIComponent(fdrUtmSource);
      console.log('utm_source added to payload:', fdrUtmSource);
    }

    console.log('submitAddons: validQueryData = ', validQueryData);

    this.submitButton.innerText = "Submit Request...";
    this.submitButton.disabled = true;
    this.waitModal.style.display = 'block';

    $.ajax({
      type: "POST",
      url: integro_url,
      data: validQueryData,
      dataType: "json",
      success: function (data) {
        if (data) {
          console.log(data);
          console.log(data.draft_name);
          localStorage.setItem("fdrproductinfo", '');
          localStorage.removeItem('fdr_utm_source');
          window.location.href =
            "/pages/thank-you-fdr?name=" +
            data.draft_name +
            "&details=" +
            data.details;
        }
      },
      fail: function (jqXHR, textStatus) {
        console.log(jqXHR + " -- " + textStatus);
        $loadingbtn.removeClass("spinning");
        this.submitButton.disabled = false;
        this.waitModal.style.display = 'none';
        alert("Process failed, please reload the page and try again");
      },
    });
}

  saveAndAddMore() {
    const validForm = this.requiredFieldsValid();
    const validFormData = new FormData(this.form);
    const validQueryData = new URLSearchParams(validFormData).toString();

    
      localStorage.setItem("fdrpersonalinfo", '');
      if(validQueryData){
        localStorage.setItem("fdrpersonalinfo", validQueryData);
      }
      window.location.href = '/pages/fdr-step-1';
  }
}

customElements.define('fdr-personal-info--form', FdrPersonalInfoForm);

// class VariantFdrSelects extends HTMLElement {
//   constructor() {
//     super();
//     this.addEventListener('change', this.onVariantChange);
//   }

//   onVariantChange(event) {
//     console.log('got variant change ',event);
//     console.log('variant info: ',this.currentVariant);    
//     this.updateOptions();
//     this.updateMasterId();
//     this.updateMetafields();
//     //this.toggleAddButton(true, '', false);
//     this.updatePickupAvailability();
//     this.removeErrorMessage();
//     //this.updateDisabledOptions();
//     this.hideConditional();
//     this.updateVariantInput(event);

//   console.log('this.currentVariant after masterID',this.currentVariant)
//     if (!this.currentVariant) {
//       this.toggleAddButton(true, '', true);
//       this.setUnavailable();
//     } else {
//       // this.updateSkuinfo();
//       this.updateMedia();
//       // this.updateURL();
//       //this.updateOptionText();
//       this.updateVariantInput(event);
//       this.renderProductInfo();
//       this.updateCustomInputs();
//     }
//     this.outOfStock();
//   }

//   hideConditional(){
   
//     var option1 = $('variant-fdr-radios fieldset.product-form__input[data-option="option1"]').find("input:checked").val();
//     var option1_remove = '';
//     if (option1) {
//       option1_remove = option1.replace(/'/g, '').replace(/"/g, '');
//     }
    
//     var wxVariantSelect = $("select.variants-wx-select");
//     var variantData = this.getVariantData();

//     // Reset all options to enabled first
//     $('variant-fdr-radios fieldset.product-form__input[data-option="option2"] input').removeAttr('disabled');
//     $('variant-fdr-radios fieldset.product-form__input[data-option="option3"] input').removeAttr('disabled');
//     $('variant-fdr-radios fieldset.product-form__input[data-option="option2"] label').show();
//     $('variant-fdr-radios fieldset.product-form__input[data-option="option3"] label').show();
//     $('variant-fdr-radios fieldset.product-form__input[data-option="option2"] input').removeClass('disabled');
//     $('variant-fdr-radios fieldset.product-form__input[data-option="option3"] input').removeClass('disabled');

//     if (option1) {
//       // Get available options for option2 based on selected option1
//       var availableOption2 = [];
//       variantData.forEach(variant => {
//         if (variant.option1 === option1 && !availableOption2.includes(variant.option2)) {
//           availableOption2.push(variant.option2);
//         }
//       });

//       // Disable unavailable option2 values
//       $('variant-fdr-radios fieldset.product-form__input[data-option="option2"] input').each(function() {
//         var option2Value = $(this).val();
//         if (!availableOption2.includes(option2Value)) {
//           setTimeout(() => {
//             $(this).attr('disabled', 'disabled');
//             $(this).addClass('disabled');
//           }, 500);
//           //$(this).next('label').hide();
//         }
//       });

//       // Get selected option2
//       var option2 = $('variant-fdr-radios fieldset.product-form__input[data-option="option2"]').find("input:checked").val();
      
//       if (option2) {
//         // Get available options for option3 based on selected option1 and option2
//         var availableOption3 = [];
//         variantData.forEach(variant => {
//           if (variant.option1 === option1 && variant.option2 === option2 && !availableOption3.includes(variant.option3)) {
//             availableOption3.push(variant.option3);
//           }
//         });

//         // Disable unavailable option3 values
//         $('variant-fdr-radios fieldset.product-form__input[data-option="option3"] input').each(function() {
//           var option3Value = $(this).val();
//           if (!availableOption3.includes(option3Value)) {
//             setTimeout(() => {
//               $(this).attr('disabled', 'disabled');
//               $(this).addClass('disabled');  
//             }, 500);
//             //$(this).next('label').hide();
//           }
//         });
//       }
//     }

//     // Handle thumbnail slider visibility
//     $('.thumbnail-change-slider').addClass('activeSlider');
//     var checkedValues = $('variant-fdr-radios fieldset.product-form__input input:checked').map(function() {
//       return $(this).val();
//     }).get();
//     var allCheckedValues = checkedValues.join(" / ").replace(/'/g, '').replace(/"/g, '');

//     // Hide all thumbnails first
//       $('.thumbnail-change-slider .thumbnail-list__item:not(.donthideit)').removeClass('showimage').hide();

//     // Show matching thumbnail based on selected options
//     if ($('.thumbnail-change-slider .thumbnail-list__item[data-final-alt="' + allCheckedValues + '"]').length > 0) {
//       $('.thumbnail-change-slider .thumbnail-list__item[data-final-alt="' + allCheckedValues + '"]').addClass('showimage').show();
//     } else if ($('.thumbnail-change-slider .thumbnail-list__item[data-alt="' + option1_remove + '"]').length > 0) {
//       $('.thumbnail-change-slider .thumbnail-list__item[data-alt="' + option1_remove + '"]').addClass('showimage').show();
//     }
//   }

  
//   outOfStock(){
//     $('.quick-add-modal--form .product-form__input input[type=radio]').remove('disabled', 'disabled');
//     if(this.currentVariant && this.currentVariant.available == false){
//       $('.quick-add-modal--form .product-form__input input[type=radio]:checked').attr('disabled', 'disabled');
//     }
//   }
//   updateOptions() {
//     const fieldsets = Array.from(this.querySelectorAll('fieldset'));
//     this.options = fieldsets.map((fieldset) => {
//       return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
//     });
//   }


//   updateDisabledOptions() {


//     const option1Fieldset = this.querySelector('fieldset[data-option="option1"]');
//     const option2Fieldset = this.querySelector('fieldset[data-option="option2"]');
//     const option3Fieldset = this.querySelector('fieldset[data-option="option3"]');
//     if(option1Fieldset && option2Fieldset) {
//       var option1Inputs = option1Fieldset.querySelectorAll('input');
//       for (var i = 0; i < option1Inputs.length; i++) {
//         option1Inputs[i].disabled = true;
//         option1Inputs[i].setAttribute('data-availability','false');
//       }
//     }
//     if(option2Fieldset) {
//       var option2Inputs = option2Fieldset.querySelectorAll('input');
//       for (var i = 0; i < option2Inputs.length; i++) {
//         option2Inputs[i].disabled = true;
//         option2Inputs[i].setAttribute('data-availability','false');
//       }
//     }
//     if(option3Fieldset) {
//       var option3Inputs = option3Fieldset.querySelectorAll('input');
//       for (var i = 0; i < option3Inputs.length; i++) {
//         option3Inputs[i].disabled = true;
//         option3Inputs[i].setAttribute('data-availability','false');
//       }
//     }
//     this.options.forEach((option,index) => {
//       var curr_option = option,
//           curr_option_index = 'option'+(index+1),
//           matching_variants = this.getVariantData().filter(function(element,index) {
//             return element[curr_option_index] == curr_option;
//           });
//       let option1 = matching_variants.map(a => a.option1);
//       let option2 = matching_variants.map(a => a.option2);
//       let option3 = matching_variants.map(a => a.option3);
//       switch(index) {
//         case 0:
//           if(!option2Fieldset) return;
//             this.variantExistsCheck(option2Inputs,option2);
//           if(!option3Fieldset) return;
//             this.variantExistsCheck(option3Inputs,option3);
//           break;
//         case 1:
//           if(!option1Fieldset) return;
//             this.variantExistsCheck(option1Inputs,option1);
//           if(!option3Fieldset) return;
//             this.variantExistsCheck(option3Inputs,option3);
//           break;
//         case 2:
//           if(!option1Fieldset) return;
//             this.variantExistsCheck(option1Inputs,option1);
//           if(!option2Fieldset) return;
//             this.variantExistsCheck(option2Inputs,option2);
//       }
//     });
//   }

//   updateMasterId() {
//     console.log('this.getVariantData()',this.getVariantData())
//     this.currentVariant = this.getVariantData().find((variant) => {
//       return !variant.options.map((option, index) => {
//         return this.options[index] === option;
//       }).includes(false);
//     });
//   }
//   updateMetafields() {
//     if(!this.parentElement.querySelector('#pro-metafields')) return;
//     const metafieldData = JSON.parse(this.parentElement.querySelector('#pro-metafields').textContent);
//     this.currentVariantMetafield = metafieldData.find((variant) => variant.id === this.currentVariant.id);
//   }
  

//   updateMedia() {
//     if (!this.currentVariant) return;
//     if(!this.currentVariant.featured_media) return;
//     const mediaId = this.currentVariant.featured_image.id;
//     const mediaWrap = this.closest('.quick-add-modal--form').querySelector('.quick-add-modal-product--media-list');
//     const mediaList = mediaWrap.querySelectorAll('li');

//     mediaList.forEach((mediaCell) => {
//       mediaCell.classList.remove('is-active');
//       if(mediaCell.dataset.mediaId == `quick-add-modal-product__media-item-${mediaId}`){
//         mediaCell.classList.add('is-active');
//       }
//     })
//   }

//   updateExceptVariantInput(event) {
//     const inputTarget = event.target;
//     this.getVariantData().find((variant) => {
//       inputTarget.closest('.product-form__input').querySelector('.js-form--label-value').innerText = inputTarget.value;
//     });
//   }

//   updateVariantInput(event) {
//     const inputTarget = event.target;
//     // console.log('updating variant info',getCurrentVariant());
//     console.log('this.getVariantData()',this.getVariantData())
    
//     $('.quick-add-modal--form .product-form__input input[type=radio]').removeAttr('disabled');
//     this.currentVariant = this.getVariantData().find((variant) => {
//       console.log('this.currentVariant',this.currentVariant)
//       const productForm = this.closest('.fdr-product-content').querySelector('form');
//       const input = productForm.querySelector('input[name="id"]');
//       const vid =  this.currentVariant.id;
//       if(this.currentVariant.available == false){
//         $('.quick-add-modal--form .product-form__input input[type=radio]:checked').attr('disabled', 'disabled');
//       }
//       $('.js-quick-next-submit').removeAttr('disabled');
//       $('.js-quick-next-submit').html('Submit Request <i class="fal fa-angle-right ion-md-add"></i>');
//       if(this.currentVariant.available == false){
//         $('.js-quick-next-submit').attr('disabled', 'disabled');
//         $('.js-quick-next-submit').text('SOLD OUT');
//       }
//       input.value = this.currentVariant.id;
//       $('.quick-add-modal__content-info:visible input[name="id"]').val(vid);
//       //update price
//       const curprice = this.currentVariant.price/100;
//       var commaNum = numberWithCommas(curprice);
//       $('.price-item.price-item--regular').text("$"+commaNum);

//       inputTarget.closest('.product-form__input').querySelector('.js-form--label-value').innerText = inputTarget.value;
//     });
//   }

//   updatePickupAvailability() {
//     const pickUpAvailability = document.querySelector('pickup-availability');
//     if (!pickUpAvailability) return;

//     if (this.currentVariant && this.currentVariant.available) {
//       pickUpAvailability.fetchAvailability(this.currentVariant.id);
//     } else {
//       pickUpAvailability.removeAttribute('available');
//       pickUpAvailability.innerHTML = '';
//     }
//   }
//   removeErrorMessage() {
//   }

//   renderProductInfo() {
//   }

//   getVariantData() {
//     this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
//     return this.variantData;
//   }

//   toggleAddButton(disable = true, text, modifyClass = true) {
    
//   }

//   setUnavailable() {
    
//   }


//   variantExistsCheck(inputs,options) {
//     for (var i = 0; i < inputs.length; i++) {
//       if(options.includes(inputs[i].value)) {
//         inputs[i].disabled = false;
//         inputs[i].setAttribute('data-availability','true');
//       } 
//     }
//   }
// }

// customElements.define('variant-fdr-radios', VariantFdrSelects);

class VariantFdrSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    console.log('got variant change ', event);
    console.log('variant info: ', this.currentVariant);
    this.updateOptions();
    this.updateMasterId();
    this.updateMetafields();
    //this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    //this.updateDisabledOptions();
    this.hideConditional();
    this.updateVariantInput(event);

    console.log('this.currentVariant after masterID', this.currentVariant)
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      // this.updateSkuinfo();
      this.updateMedia();
      // this.updateURL();
      //this.updateOptionText();
      this.updateVariantInput(event);
      this.renderProductInfo();
      this.updateCustomInputs();
    }
    this.outOfStock();
  }

  hideConditional() {

    var option1 = $('variant-fdr-radios fieldset.product-form__input[data-option="option1"]').find("input:checked").val();
    var option1_remove = '';
    if (option1) {
      option1_remove = option1.replace(/'/g, '').replace(/"/g, '');
    }

    var wxVariantSelect = $("select.variants-wx-select");
    var variantData = this.getVariantData();

    // Reset all options to enabled first
    $('variant-fdr-radios fieldset.product-form__input[data-option="option2"] input').removeAttr('disabled');
    $('variant-fdr-radios fieldset.product-form__input[data-option="option3"] input').removeAttr('disabled');
    $('variant-fdr-radios fieldset.product-form__input[data-option="option2"] label').show();
    $('variant-fdr-radios fieldset.product-form__input[data-option="option3"] label').show();
    $('variant-fdr-radios fieldset.product-form__input[data-option="option2"] input').removeClass('disabled');
    $('variant-fdr-radios fieldset.product-form__input[data-option="option3"] input').removeClass('disabled');

    if (option1) {
      // Get available options for option2 based on selected option1
      var availableOption2 = [];
      variantData.forEach(variant => {
        if (variant.option1 === option1 && !availableOption2.includes(variant.option2)) {
          availableOption2.push(variant.option2);
        }
      });

      // Disable unavailable option2 values
      $('variant-fdr-radios fieldset.product-form__input[data-option="option2"] input').each(function () {
        var option2Value = $(this).val();
        if (!availableOption2.includes(option2Value)) {
          setTimeout(() => {
            $(this).attr('disabled', 'disabled');
            $(this).addClass('disabled');
          }, 500);
          //$(this).next('label').hide();
        }
      });

      // Get selected option2
      var option2 = $('variant-fdr-radios fieldset.product-form__input[data-option="option2"]').find("input:checked").val();

      if (option2) {
        // Get available options for option3 based on selected option1 and option2
        var availableOption3 = [];
        variantData.forEach(variant => {
          if (variant.option1 === option1 && variant.option2 === option2 && !availableOption3.includes(variant.option3)) {
            availableOption3.push(variant.option3);
          }
        });

        // Disable unavailable option3 values
        $('variant-fdr-radios fieldset.product-form__input[data-option="option3"] input').each(function () {
          var option3Value = $(this).val();
          if (!availableOption3.includes(option3Value)) {
            setTimeout(() => {
              $(this).attr('disabled', 'disabled');
              $(this).addClass('disabled');
            }, 500);
            //$(this).next('label').hide();
          }
        });
      }
    }

    // Handle thumbnail slider visibility
    $('.thumbnail-change-slider').addClass('activeSlider');
    var checkedValues = $('variant-fdr-radios fieldset.product-form__input input:checked').map(function () {
      return $(this).val();
    }).get();
    var allCheckedValues = checkedValues.join(" / ").replace(/'/g, '').replace(/"/g, '');

    // Hide all thumbnails first
    $('.thumbnail-change-slider .thumbnail-list__item:not(.donthideit)').removeClass('showimage').hide();

    // Show matching thumbnail based on selected options
    if ($('.thumbnail-change-slider .thumbnail-list__item[data-final-alt="' + allCheckedValues + '"]').length > 0) {
      $('.thumbnail-change-slider .thumbnail-list__item[data-final-alt="' + allCheckedValues + '"]').addClass('showimage').show();
    } else if ($('.thumbnail-change-slider .thumbnail-list__item[data-alt="' + option1_remove + '"]').length > 0) {
      $('.thumbnail-change-slider .thumbnail-list__item[data-alt="' + option1_remove + '"]').addClass('showimage').show();
    }
  }


  outOfStock() {
    $('.quick-add-modal--form .product-form__input input[type=radio]').remove('disabled', 'disabled');
    if (this.currentVariant && this.currentVariant.available == false) {
      $('.quick-add-modal--form .product-form__input input[type=radio]:checked').attr('disabled', 'disabled');
    }
  }
  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }


  updateDisabledOptions() {


    const option1Fieldset = this.querySelector('fieldset[data-option="option1"]');
    const option2Fieldset = this.querySelector('fieldset[data-option="option2"]');
    const option3Fieldset = this.querySelector('fieldset[data-option="option3"]');
    if (option1Fieldset && option2Fieldset) {
      var option1Inputs = option1Fieldset.querySelectorAll('input');
      for (var i = 0; i < option1Inputs.length; i++) {
        option1Inputs[i].disabled = true;
        option1Inputs[i].setAttribute('data-availability', 'false');
      }
    }
    if (option2Fieldset) {
      var option2Inputs = option2Fieldset.querySelectorAll('input');
      for (var i = 0; i < option2Inputs.length; i++) {
        option2Inputs[i].disabled = true;
        option2Inputs[i].setAttribute('data-availability', 'false');
      }
    }
    if (option3Fieldset) {
      var option3Inputs = option3Fieldset.querySelectorAll('input');
      for (var i = 0; i < option3Inputs.length; i++) {
        option3Inputs[i].disabled = true;
        option3Inputs[i].setAttribute('data-availability', 'false');
      }
    }
    this.options.forEach((option, index) => {
      var curr_option = option,
        curr_option_index = 'option' + (index + 1),
        matching_variants = this.getVariantData().filter(function (element, index) {
          return element[curr_option_index] == curr_option;
        });
      let option1 = matching_variants.map(a => a.option1);
      let option2 = matching_variants.map(a => a.option2);
      let option3 = matching_variants.map(a => a.option3);
      switch (index) {
        case 0:
          if (!option2Fieldset) return;
          this.variantExistsCheck(option2Inputs, option2);
          if (!option3Fieldset) return;
          this.variantExistsCheck(option3Inputs, option3);
          break;
        case 1:
          if (!option1Fieldset) return;
          this.variantExistsCheck(option1Inputs, option1);
          if (!option3Fieldset) return;
          this.variantExistsCheck(option3Inputs, option3);
          break;
        case 2:
          if (!option1Fieldset) return;
          this.variantExistsCheck(option1Inputs, option1);
          if (!option2Fieldset) return;
          this.variantExistsCheck(option2Inputs, option2);
      }
    });
  }

  updateMasterId() {
    console.log('this.getVariantData()', this.getVariantData())
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }
  updateMetafields() {
    if (!this.parentElement.querySelector('#pro-metafields')) return;
    const metafieldData = JSON.parse(this.parentElement.querySelector('#pro-metafields').textContent);
    this.currentVariantMetafield = metafieldData.find((variant) => variant.id === this.currentVariant.id);
  }


  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const mediaId = this.currentVariant.featured_image.id;
    const mediaWrap = this.closest('.quick-add-modal--form').querySelector('.quick-add-modal-product--media-list');
    const mediaList = mediaWrap.querySelectorAll('li');

    mediaList.forEach((mediaCell) => {
      mediaCell.classList.remove('is-active');
      if (mediaCell.dataset.mediaId == `quick-add-modal-product__media-item-${mediaId}`) {
        mediaCell.classList.add('is-active');
      }
    })
  }

  updateExceptVariantInput(event) {
    const inputTarget = event.target;
    this.getVariantData().find((variant) => {
      inputTarget.closest('.product-form__input').querySelector('.js-form--label-value').innerText = inputTarget.value;
    });
  }

  updateVariantInput(event) {
    const inputTarget = event.target;
    // console.log('updating variant info',getCurrentVariant());
    console.log('this.getVariantData()', this.getVariantData())

    $('.quick-add-modal--form .product-form__input input[type=radio]').removeAttr('disabled');
    this.currentVariant = this.getVariantData().find((variant) => {
      console.log('this.currentVariant', this.currentVariant)
      const productForm = this.closest('.fdr-product-content').querySelector('form');
      const input = productForm.querySelector('input[name="id"]');
      const vid = this.currentVariant.id;
      if (this.currentVariant.available == false) {
        $('.quick-add-modal--form .product-form__input input[type=radio]:checked').attr('disabled', 'disabled');
      }
      $('.js-quick-next-submit').removeAttr('disabled');
      $('.js-quick-next-submit').html('Submit Request <i class="fal fa-angle-right ion-md-add"></i>');
      if (this.currentVariant.available == false) {
        $('.js-quick-next-submit').attr('disabled', 'disabled');
        $('.js-quick-next-submit').text('SOLD OUT');
      }
      input.value = this.currentVariant.id;
      $('.quick-add-modal__content-info:visible input[name="id"]').val(vid);
      //update price
      const curprice = this.currentVariant.price / 100;
      var commaNum = numberWithCommas(curprice);

      // Console log prices
      console.log('Regular Price:', this.currentVariant.price);
      console.log('Regular Price (formatted):', "$" + commaNum);

      // Check for compare price
      if (this.currentVariant.compare_at_price) {
        const comparePrice = this.currentVariant.compare_at_price / 100;
        const compareCommaNum = numberWithCommas(comparePrice);
        console.log('Compare Price:', this.currentVariant.compare_at_price);
        console.log('Compare Price (formatted):', "$" + compareCommaNum);

        // Update both regular (compare) price and sale price
        $('.price-item.price-item--regular').text("$" + compareCommaNum);
        $('.price-item.price-item--sale').text("$" + commaNum);

        // Show the sale price container
        $('.price__sale').show();
      } else {
        console.log('Compare Price: Not available');

        // Only update regular price, hide sale price container
        $('.price-item.price-item--regular').text("$" + commaNum);
        $('.price__sale').hide();
      }

      inputTarget.closest('.product-form__input').querySelector('.js-form--label-value').innerText = inputTarget.value;
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }
  removeErrorMessage() {
  }

  renderProductInfo() {
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  toggleAddButton(disable = true, text, modifyClass = true) {

  }

  setUnavailable() {

  }


  variantExistsCheck(inputs, options) {
    for (var i = 0; i < inputs.length; i++) {
      if (options.includes(inputs[i].value)) {
        inputs[i].disabled = false;
        inputs[i].setAttribute('data-availability', 'true');
      }
    }
  }
}

customElements.define('variant-fdr-radios', VariantFdrSelects);

function numberWithCommas(number) {
    var parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

$('body').on('click','variant-fdr-radios label',function(){
  console.log('test');
  var txt = $(this).text();
  $(this).closest('.product-form__input').find ('legend .js-form--label-value').text(txt);
});